export default __webpack_public_path__ + "static/media/umi_drone.d11fb43a.png";